<template>
  <FormPanel
      headline="Create Sitemap Link"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/SitemapLinks/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/sitemap-links', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The sitemap link was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/sitemap-links')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
